import scrrroll from 'scrrroll';
import em2px from '@/utils/em2px';
import throttle from '@/utils/throttle';

export default function(dom, opts) {
	const updateOffset = () => {
		const checkoutCartButton = document.querySelector('.checkout-cart-button');
		let offset = 0;

		if (checkoutCartButton) {
			offset = checkoutCartButton.clientHeight;
		}

		scrrroll.offset = dom.clientHeight + offset + em2px(1);
	};

	window.addEventListener('resize', throttle(updateOffset));
	window.addEventListener('load', updateOffset);
	updateOffset();
}
